import { Goal, FunderOrgToSharedGoal } from 'Generated/graphql-types'

const getFunderCount = (funderOrgToSharedGoals: FunderOrgToSharedGoal[]) => {
  const uniqueFunders = new Set<number>()
  funderOrgToSharedGoals.forEach((goal) => {
    uniqueFunders.add(goal.funderOrgId)
  })

  return uniqueFunders.size
}

const checkCanGoalBeCompleted = (goal: Goal) => {
  if (goal.FunderOrgToSharedGoal.length > 0) {
    const hasSharedByFunder = goal.FunderOrgToSharedGoal.some(
      (sharedGoal: FunderOrgToSharedGoal) =>
        sharedGoal.isGoalSharedByFunder === true
    )
    if (hasSharedByFunder) {
      return false
    }
  }
  return true
}

export { getFunderCount, checkCanGoalBeCompleted }
